const toRadians = (n: number) => (n * Math.PI) / 180
const defaultPoint = { lat: 0, lng: 0 }

export const calculateSphericalDistance = (
  p1 = defaultPoint,
  p2 = defaultPoint
) => {
  const { lat: lat1, lng: lon1 } = p1
  const { lat: lat2, lng: lon2 } = p2

  const R = 6371e3 // metres
  const φ1 = toRadians(lat1)
  const φ2 = toRadians(lat2)
  const Δφ = toRadians(lat2 - lat1)
  const Δλ = toRadians(lon2 - lon1)

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}
